export default __webpack_public_path__ + "static/orbit-5062927b12de8014c97ff8083273ccec.png";